module.exports = __webpack_public_path__ + "static/media/warning.6f266757.svg";